import GroupApi from '@api/GroupApi'

const state = {
  currentSubGroupDetailsLoading: true,
  currentSubGroupDetails: []
}

const mutations = {
  BEGIN_LOADING_SUBGROUP_PLANS_DETAILS (state) {
    state.currentSubGroupDetailsLoading = true
  },
  setClassDetails(state, details) {
    state.currentSubGroupDetails = details.subGroups
    state.currentSubGroupDetailsLoading = false
  }
}

const getters = {
  currentSubGroupDetailsLoading(state) {
    return state.currentSubGroupDetailsLoading
  },
  currentSubGroupDetails(state) {
    return state.currentSubGroupDetails
  }
}

const actions = {
  GET_SUBGROUP_PLANS_DETAILS(context) {
    context.commit('BEGIN_LOADING_SUBGROUP_PLANS_DETAILS')
    if (context.rootGetters['groupSelector/selected'].subGroupCk) {
      new GroupApi()
        .classPlans({
          subGroupCk: context.rootGetters['groupSelector/selected'].subGroupCk
        })
        .then(res => {
          context.commit('setClassDetails', res)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}

export const providerLocator = {
  namespaced: false,
  state,
  mutations,
  actions,
  getters
}
